import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { CustomFieldDefinition } from '@teetsh/app/src/types/customField';

export const ELEVES_CUSTOM_FIELDS_KEY = 'elevesCustomFields';

export default function useElevesCustomFields() {
  const { schoolyear, school } = useSchoolSchoolyear();
  return useQuery({
    queryKey: [ELEVES_CUSTOM_FIELDS_KEY, schoolyear.id, school.id],
    queryFn: () =>
      request(
        `/schoolyears/${schoolyear.id}/schools/${school.id}/eleves-custom-fields`,
        {
          method: 'GET',
        },
      ).then<CustomFieldDefinition[]>(res => res.data || []),

    refetchOnWindowFocus: false,
  });
}
